var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramOutlineWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7461 6.16602H20.4128M7.91276 1.16602H17.9128C19.6809 1.16602 21.3766 1.86839 22.6268 3.11864C23.877 4.36888 24.5794 6.06457 24.5794 7.83268V17.8327C24.5794 19.6008 23.877 21.2965 22.6268 22.5467C21.3766 23.797 19.6809 24.4994 17.9128 24.4994H7.91276C6.14465 24.4994 4.44896 23.797 3.19872 22.5467C1.94847 21.2965 1.24609 19.6008 1.24609 17.8327V7.83268C1.24609 6.06457 1.94847 4.36888 3.19872 3.11864C4.44896 1.86839 6.14465 1.16602 7.91276 1.16602ZM12.9128 17.8327C11.5867 17.8327 10.3149 17.3059 9.37723 16.3682C8.43955 15.4305 7.91276 14.1588 7.91276 12.8327C7.91276 11.5066 8.43955 10.2348 9.37723 9.29715C10.3149 8.35947 11.5867 7.83268 12.9128 7.83268C14.2388 7.83268 15.5106 8.35947 16.4483 9.29715C17.386 10.2348 17.9128 11.5066 17.9128 12.8327C17.9128 14.1588 17.386 15.4305 16.4483 16.3682C15.5106 17.3059 14.2388 17.8327 12.9128 17.8327Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.414062 0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramOutlineWhite);
export default __webpack_public_path__ + "static/media/instagram-outlineWhite.ce6eca83ab0e0eb12b9d252fd2a93f13.svg";
export { ForwardRef as ReactComponent };